module.exports = [{
      plugin: require('../node_modules/@prismicio/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"bemeliorismwebsite","defaultLang":"en-us","accessToken":"MC5Yd2FsY0JBQUFDSUE5R25n.Fu-_ve-_ve-_vXvvv73vv71877-9ICXvv73vv70Kde-_vSY-77-9fBob77-977-9Su-_ve-_ve-_vXzvv73vv73vv70","path":"/preview","previews":true,"sharpKeys":[{},"profilepic"],"pages":[{"type":"Policy","match":"/policy/:uid","previewPath":"/policy","component":"/opt/build/repo/src/templates/policy.js"}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Meliorism","short_name":"Meliorism","start_url":"/","background_color":"#FFFFFF","theme_color":"#7D06E3","display":"minimal-ui","icon":"src/images/menu/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"ca53df4f8ecc5c5aa2a1e5d8e443c13e"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
